import { useToast } from '@chakra-ui/react';

import { AuthLayout } from '../components/AuthLayout';
import { LoginContainer } from '../components/LoginContainer';

export const Login = () => {
  const toast = useToast();

  return (
    <AuthLayout title="Entrar na plataforma">
      <LoginContainer
        onSuccess={() => {
          toast({
            title: 'Logado com sucesso.',
            status: 'success',
            duration: 5000,
            isClosable: true,
          });
          window.location.reload();
        }}
        onError={(message) =>
          toast({
            title: message,
            status: 'error',
            duration: 5000,
            isClosable: true,
          })
        }
      />
    </AuthLayout>
  );
};
